<template>
  <div class="mt-4 row">
    <div class="col-12">
      <div>
        <cabecalho title="FICHA_SAUDE.FICHA_SAUDE" title_type="body" />
      </div>
      <p>{{ $t('FICHA_SAUDE.SOBRE') }}</p>
    </div>
    <div class="col-12">
      <div class="mt-4">
        <h4>
          {{ $t('FICHA_SAUDE.OBSERVACOES') }}
        </h4>
        <b-row>
          <input-text
            class="col-6"
            ref="fichaSaude.planoDeSaude"
            v-model="fichaSaude.planoDeSaude"
            :label="$t('FICHA_SAUDE.PLANO_SAUDE')"
            :placeholder="$t('FICHA_SAUDE.PLANO_SAUDE_PLACEHOLDER')"
          />
          <input-text
            class="col-6"
            ref="fichaSaude.numeroCarteirinha"
            v-model="fichaSaude.numeroCarteirinha"
            :label="$t('FICHA_SAUDE.PLANO_SAUDE_NUMERO_CARTEIRINHA')"
            :placeholder="
              $t('FICHA_SAUDE.PLANO_SAUDE_NUMERO_CARTEIRINHA_PLACEHOLDER')
            "
          />
        </b-row>
      </div>
      <div class="mt-4">
        <h4>
          {{ $t('FICHA_SAUDE.INTOLERANCIAS') }}
        </h4>
        <b-row>
          <b-col class="col-3">
            <input-checkbox
              ref="fichaSaude.intoleranciaLactose"
              v-model="fichaSaude.intoleranciaLactose"
              :label="$t('FICHA_SAUDE.INTOLERANCIAS_LACTOSE')"
            />
          </b-col>
          <b-col class="col-3">
            <input-checkbox
              ref="fichaSaude.intoleranciaGluten"
              v-model="fichaSaude.intoleranciaGluten"
              :label="$t('FICHA_SAUDE.INTOLERANCIAS_GLUTEN')"
            />
          </b-col>
          <b-col class="col-3">
            <input-checkbox
              ref="fichaSaude.refluxo"
              v-model="fichaSaude.refluxo"
              :label="$t('FICHA_SAUDE.REFLUXO')"
            />
          </b-col>
        </b-row>
      </div>
      <div class="mt-4">
        <h4>
          {{ $t('FICHA_SAUDE.MEDICACOES') }}
        </h4>
        <b-row>
          <b-col class="col-12">
            <input-checkbox
              ref="fichaSaude.medicamentoContinuo"
              v-model="fichaSaude.medicamentoContinuo"
              class="mt-1"
              :label="$t('FICHA_SAUDE.MEDICACOES_CONFIRMACAO')"
            />
          </b-col>
          <b-col>
            <input-text
              ref="fichaSaude.nomeMedicamento"
              v-model="fichaSaude.nomeMedicamento"
              :label="$t('FICHA_SAUDE.MEDICACOES_QUAIS')"
              :required="fichaSaude.medicamentoContinuo"
              :disabled="!fichaSaude.medicamentoContinuo"
            />
          </b-col>
          <b-col>
            <input-text
              ref="fichaSaude.motivoMedicamento"
              v-model="fichaSaude.motivoMedicamento"
              :label="$t('FICHA_SAUDE.MEDICACOES_MOTIVO')"
              :required="fichaSaude.medicamentoContinuo"
              :disabled="!fichaSaude.medicamentoContinuo"
            />
          </b-col>
        </b-row>
      </div>
      <div class="mt-4">
        <h4>
          {{ $t('FICHA_SAUDE.ALERGIAS') }}
        </h4>
        <b-row>
          <b-col class="col-12">
            <input-checkbox
              ref="fichaSaude.alergia"
              v-model="fichaSaude.alergia"
              :label="$t('FICHA_SAUDE.ALERGIA_CONFIRMACAO')"
            />
          </b-col>
          <b-col>
            <input-text
              ref="fichaSaude.especificaoAlergia"
              :required="fichaSaude.alergia"
              :disabled="!fichaSaude.alergia"
              v-model="fichaSaude.especificaoAlergia"
              :label="$t('FICHA_SAUDE.ALERGIA_QUAIS')"
            />
          </b-col>
        </b-row>
      </div>
      <div class="mt-4">
        <h4>
          {{ $t('FICHA_SAUDE.DEFICIENCIAS') }}
        </h4>
        <b-row>
          <b-col>
            <input-checkbox
              ref="fichaSaude.deficiencia"
              v-model="fichaSaude.deficiencia"
              class="mt-1"
              :label="$t('FICHA_SAUDE.DEFICIENCIAS_CONFIRMACAO')"
            />
            <input-text
              ref="fichaSaude.especificacaoDeficiencia"
              :required="fichaSaude.deficiencia"
              :disabled="!fichaSaude.deficiencia"
              v-model="fichaSaude.especificacaoDeficiencia"
              :label="$t('FICHA_SAUDE.DEFICIENCIAS_ESPECIFIQUE')"
              :placeholder="$t('FICHA_SAUDE.DEFICIENCIAS_DESCRICAO_CID')"
            />
          </b-col>
          <b-col>
            <p>{{ $t('FICHA_SAUDE.DEFICIENCIAS_SELECIONE') }}</p>
            <b-row>
              <b-col>
                <input-checkbox
                  ref="deficienciaFisica"
                  v-model="fichaSaude.deficienciaFisica"
                  :label="$t('FICHA_SAUDE.DEFICIENCIA_FISICA')"
                  :disabled="!fichaSaude.deficiencia"
                />
                <input-checkbox
                  ref="deficienciaVisual"
                  v-model="fichaSaude.deficienciaVisual"
                  :label="$t('FICHA_SAUDE.DEFICIENCIA_VISUAL')"
                  :disabled="!fichaSaude.deficiencia"
                />
                <input-checkbox
                  ref="deficienciaAuditiva"
                  v-model="fichaSaude.deficienciaAuditiva"
                  :label="$t('FICHA_SAUDE.DEFICIENCIA_AUDITIVA')"
                  :disabled="!fichaSaude.deficiencia"
                />
              </b-col>
              <b-col>
                <input-checkbox
                  ref="deficienciaIntelectual"
                  v-model="fichaSaude.deficienciaIntelectual"
                  :label="$t('FICHA_SAUDE.DEFICIENCIA_INTELECTUAL')"
                  :disabled="!fichaSaude.deficiencia"
                />
                <input-checkbox
                  ref="deficienciaPsicossocial"
                  v-model="fichaSaude.deficienciaPsicossocial"
                  :label="$t('FICHA_SAUDE.DEFICIENCIA_PSICOSSOCIAL')"
                  :disabled="!fichaSaude.deficiencia"
                />
                <input-checkbox
                  ref="deficienciaMultipla"
                  v-model="fichaSaude.deficienciaMultipla"
                  :label="$t('FICHA_SAUDE.DEFICIENCIA_MULTIPLA')"
                  :disabled="!fichaSaude.deficiencia"
                />
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>
      <div class="mt-4">
        <h4>
          {{ $t('FICHA_SAUDE.OBSERVACOES') }}
        </h4>
        <b-row class="mt-4">
          <b-col>
            <InputTextArea
              ref="fichaSaude.observacoes"
              v-model="fichaSaude.observacoes"
              :label="$t('FICHA_SAUDE.OBSERVACOES_OUTRAS')"
            />
          </b-col>
        </b-row>
      </div>
      <b-row>
        <b-col class="d-flex">
          <input-checkbox
            v-model="declaracaoCheck"
            ref="confirmacao"
            required
          />
          <p>{{ $t('FICHA_SAUDE.DECLARAR_VERDADEIRO') }}</p>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import helpers from '@/common/utils/helpers';

import { Cabecalho } from '@/components/headers/index';
import InputCheckbox from '@/components/inputs/InputCheckbox.vue';
import InputText from '@/components/inputs/InputText.vue';
import InputTextArea from '@/components/inputs/InputTextArea.vue';

export default {
  components: {
    InputCheckbox,
    InputText,
    InputTextArea,
    Cabecalho,
  },
  props: {
    fichaSaude: { type: Object, default: Object },
  },
  data() {
    return {
      declaracaoCheck: false,
    };
  },
  methods: {
    validarFormulario() {
      return helpers.validarFormulario(this.$refs);
    },
  },
};
</script>
